import PhsLogsListPage from "./pages/PhsLogsListPage.vue";

export default {
    PhsLogsListPage,
};
